import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  withRouter,
  NavLink as Link,
} from 'react-router-dom';
import './Login.css';

const getRedirectParam = (search) => {
  return search.replace(/\??/, '').split('&').reduce((val, item) => {
    const split = item.split('=');
    if ( split[0] === "redirectTo" ) {
      return decodeURIComponent(split[1]);
    }
    return val;
  }, null);
};

class Login extends Component {

  componentWillMount() {
    if ( this.props.authenticated ) {
      this.props.history.push(getRedirectParam(this.props.history.location.search) || '/');
    }
  }

  componentWillReceiveProps(nextProps) {
    if ( nextProps.authenticated ) {
      nextProps.history.push(getRedirectParam(nextProps.history.location.search) || '/');
    }
  }

  loginWithGoogle = () => {
    this.props.loginViaGoogle();
  }

  loginWithFacebook = () => {
    this.props.loginViaFacebook();
  }

  render() {
    const {loginError, networkStatus} = this.props;
    if ( this.props.authenticated ) {
      return (
        <div className="Login">
          <p> You're already logged in, <Link to="/">click here to go to the homepage.</Link> </p>
        </div>
      )
    } else {
      return (
        <div className="Login">
          <button className="google" onClick={this.loginWithGoogle} disabled={!networkStatus}> LOG IN WITH GOOGLE </button>
          <button className="facebook" onClick={this.loginWithFacebook} disabled={!networkStatus}> LOG IN WITH FACEBOOK </button>
          {loginError && (
            <div className="error">
              <h4> Error logging in </h4>
              <p> {loginError} </p>
            </div>
          )}
        </div>
      );
    }
  }

}

Login.propTypes = {
  loginViaGoogle: PropTypes.func.isRequired,
  loginViaFacebook: PropTypes.func.isRequired,
  authenticated: PropTypes.bool.isRequired,
  loginError: PropTypes.string,
  networkStatus: PropTypes.bool.isRequired,
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/component/organisms/Login/component.js